/* =================== BLOG / PRODUTOS — Filtro de Categoria Mobile =================== */
document.addEventListener("DOMContentLoaded", function () {
  var sel = document.querySelector("#prod-cat-mb");
  if (!sel) return;

  sel.addEventListener("change", function () {
    location.href = this.value;
  });
});
